<template>
  <div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      seconds: 5,
      orderNum: '',
      respCode: 1,
      respCodeNum: 1,
    }
  },
  methods: {
    paytype() {
      // let params = {
      //   orderNum: this.orderNum
      // }
      // let res = {
      //     "code": 200,
      //     "data": {
      //       "respCode": 10002,
      //       "respMessage": "wait",
      //       "agentId": null,
      //       "orderNo": null,
      //       "orderNum": "hs202512021259080521341vJd",
      //       "amount": null,
      //       "currency": null,
      //       "payUrl": null,
      //       "payTime": null,
      //       "billInfo": null,
      //       "sign": null
      //     },
      //     "message": "success"
      //   }
        // res.data.data
      this.$axios.get('https://www.omniresourcebuy.com/v1.0/evoOrderDs',{
        params: {
          orderNum: this.orderNum,
        }
      }).then((res) => {
        res = res.data
        this.respCode = res.data.respCode
        if (res.data.respCode == '10002') {
          this.respCode = '100002'
        } else if (res.data.respCode == '10000') {
          if (res.data.payUrl) {
            window.location.href = res.data.payUrl;
          }
        } else if (res.data.respCode == '10001') {
          if (res.data.payUrl) {
            window.location.href = res.data.payUrl;
          }
        }
        
      })
    }
  },
  watch:{
  respCode: {
      handler(newVal, oldVal) {
        if (this.respCode == '100002' && this.respCodeNum <= 10) {
          setTimeout(() => {
            this.paytype()
            this.respCodeNum = this.respCodeNum + 1
            console.log(this.respCodeNum);
          }, 800);
        } else {
          this.$message({
              message: 'Payment processing in progress',
              offset: '100',
              center: true,
              iconClass: 'cas'
            })
        }
      },
      deep: true
    }
  },
  mounted() {
    // this.$route.query.orderNum = 'hs20251204032439054151du1z'
    this.orderNum = this.$route.query.orderNum
    this.paytype()
  },
  

}
</script>
<style>
.cas {
  display: none;
  color: #ccc;
}
</style>
